import * as React from 'react';
import { cn } from '@/lib/utils';
import { Slot } from '@radix-ui/react-slot';

const Finder = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-finder',
      // styles
      'flex max-w-full shrink-0 flex-col gap-6 rounded-[20px] border border-solid border-neutral-lightest bg-white p-5 shadow-dropshadow xl:h-[180px] xl:grow xl:flex-row xl:overflow-hidden',
      className
    )}
    {...props}
  />
));
Finder.displayName = 'Finder';

const FinderTree = React.forwardRef(({ className, ...props }, ref) => (
  <aside
    ref={ref}
    className={cn(
      'c-finder-tree',
      // styles
      'flex flex-col gap-5 xl:w-[280px] xl:shrink-0 xl:overflow-hidden xl:hover:overflow-y-auto xl:focus:overflow-y-auto 2xl:w-[320px]',
      className
    )}
    {...props}
  />
));
FinderTree.displayName = 'FinderTree';

const FinderFolder = React.forwardRef(({ className, isOpen, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-finder-folder',
      // styles
      'flex cursor-pointer items-center gap-4 rounded-xl border border-solid border-neutral-lightest bg-white px-5 py-4 transition-all hover:shadow-dropshadow',
      isOpen && 'bg-bright',
      className
    )}
    {...props}
  />
));
FinderFolder.displayName = 'FinderFolder';

const FinderFolderIcon = React.forwardRef(({ className, ...props }, ref) => (
  <Slot
    ref={ref}
    className={cn(
      'c-finder-folder-icon',
      // styles
      'mb-0 w-5 shrink-0 text-primary',
      className
    )}
    {...props}
  />
));
FinderFolderIcon.displayName = 'FinderFolderIcon';

const FinderFolderLabel = React.forwardRef(({ className, ...props }, ref) => (
  <p
    ref={ref}
    className={cn(
      'c-finder-folder-label',
      // styles
      'mb-0 w-0 shrink-0 grow truncate text-sm text-primary-dark',
      className
    )}
    {...props}
  />
));
FinderFolderLabel.displayName = 'FinderFolderLabel';

const FinderSubfolder = React.forwardRef(({ className, isExpanded = false, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-finder-subfolder',
      // styles
      'ml-8 flex flex-col gap-[10px]',
      isExpanded ? 'block' : 'hidden',
      className
    )}
    {...props}
  />
));
FinderSubfolder.displayName = 'FinderSubfolder';

const FinderTreeItem = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-finder-tree-item',
      // styles
      'flex flex-col gap-[10px]',
      className
    )}
    {...props}
  />
));
FinderTreeItem.displayName = 'FinderTreeItem';

const FinderContent = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-finder-content',
      // styles
      'border-t border-solid border-neutral-lightest px-0 py-6 xl:flex xl:grow xl:flex-col xl:overflow-y-auto xl:border-l xl:border-t-0 xl:px-6 xl:py-0',
      className
    )}
    {...props}
  />
));
FinderContent.displayName = 'FinderContent';

const FinderFavoriteIcon = React.forwardRef(({ className, isActive, ...props }, ref) => (
  <Slot
    ref={ref}
    className={cn(
      'c-finder-favorite-icon',
      // styles
      'w-4 cursor-pointer transition-colors',
      isActive && 'fill-danger stroke-danger',
      className
    )}
    {...props}
  />
));
FinderFavoriteIcon.displayName = 'FinderFavoriteIcon';

export { Finder, FinderTree, FinderFolder, FinderFolderIcon, FinderFolderLabel, FinderSubfolder, FinderTreeItem, FinderContent, FinderFavoriteIcon };
